import AuthService from "Lib/API/Auth";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setLogoImage } from "services/api/organization";
import { getAccessTokenSilently } from "utils/functions";

const useGetUserAccount = ({ member }) => {
  const dispatch = useDispatch();
  const [accountData, setAccountData] = useState("");

  useEffect(() => {
    const getUserAccount = async () => {
      const token = await getAccessTokenSilently();
      await AuthService.getUserExist(token)
        .then((res) => {
          if (res) {
            setAccountData(res);
            localStorage.setItem(
              "accountID",
              res?.user?.permissions?.linked_account?._id
            );
            localStorage.setItem("accountInfo", res);
            localStorage.setItem(
              "paymentMethod",
              JSON.stringify(res?.user?.paymentMethodCreditCard)
            );
            localStorage.setItem("checkUser", JSON.stringify(res?.exists));
            localStorage.setItem(
              "accountName",
              res?.user?.permissions?.linked_account?.family_name
            );
            localStorage.setItem(
              "orgId",
              res?.user?.permissions?.organization?._id
            );
            localStorage.setItem(
              "accountInfo",
              JSON.stringify({
                firstName: res?.user?.permissions?.linked_contact?.first_name,
                lastName: res?.user?.permissions?.linked_contact?.last_name,
                primary_email_address:
                  res?.user?.permissions?.linked_contact?.email_address,
                emergency_contact_name:
                  res?.user?.permissions?.linked_contact
                    ?.emergency_contact_name,
                emergency_contact_number:
                  res?.user?.permissions?.linked_contact
                    ?.emergency_contact_number,
                profileImage:
                  res?.user?.permissions?.linked_contact?.profile_img,
              })
            );
            localStorage.setItem(
              "organization",
              JSON.stringify(res?.user?.permissions?.organization)
            );
            localStorage.setItem(
              "linkedAccount",
              JSON.stringify(res?.user?.permissions?.linked_account)
            );
            localStorage.setItem("hasPayment", res?.user?.hasPayment);
            localStorage.setItem(
              "logoImg",
              res?.user?.permissions?.organization?.logoImg
            );
            res?.user?.permissions?.organization?.logoImg &&
              dispatch(
                setLogoImage(res?.user?.permissions?.organization?.logoImg)
              );
            localStorage.setItem(
              "orgName",
              res?.user?.permissions?.organization?.orgName
            );
            document.title = `${res?.user?.permissions?.organization?.orgName}`;
          }
        })
        .catch((err) => {
          localStorage.setItem("checkUser", err?.data?.exists);
          toastr.error("Error", err?.data?.message);
        });
    };
    if (member) {
      getUserAccount();
    }
  }, []);

  return accountData;
};

export default useGetUserAccount;
